import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade"; // efeito fade
import styles from "./css/HeroCarousel.module.css";
import { slides } from "./data";
import Slide from "./Slide";

export default function HeroCarousel() {
    const [currentBackground, setCurrentBackground] = useState(slides[0].background);

    return (
        <section id="inicio" className={styles.heroSection}>
            {/* Fundo dinâmico com blur e transição */}
            <div
                className={styles.backgroundImage}
                style={{
                    backgroundImage: `url(${currentBackground})`,
                }}
            ></div>

            {/* Carrossel Swiper */}
            <Swiper
                modules={[Navigation, Pagination, Autoplay, EffectFade]}
                effect="fade" // fade entre slides
                fadeEffect={{ crossFade: true }} // ✅ evita sobreposição
                loop={true}
                autoplay={{ delay: 12000, disableOnInteraction: false }} // 12s entre slides
                pagination={{ clickable: true }}
                navigation
                onSlideChange={(swiper) =>
                    setCurrentBackground(slides[swiper.realIndex].background)
                }
                className={styles.swiperContainer}
            >
                {slides.map((slide, index) => (
                    <SwiperSlide key={index}>
                        <Slide
                            title={slide.title}
                            subtitle={slide.subtitle}
                            image={slide.image}
                            ctaText={slide.ctaText}
                            ctaLink={slide.ctaLink}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
}
